import { useState, useEffect } from 'react'
import { makeStyles, InputAdornment, TextFieldProps } from '@material-ui/core'
import StyledTextField from './StyledTextField'

const useStyles = makeStyles(() => ({
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '17px !important'
	}
}))

/**
 * A StyledTextField that handles display of currency entry but returns the value in cents via the amountChanged callback
 * @param {TextFieldProps & {amountChanged: (e: {inCents: Number, asFormatted: string}) => any, initialValue: number, isSubtraction: boolean}} props
 * @returns
 */
const StyledCurrencyTextField = (props) => {
	const classes = useStyles()
	const [amountInDollarsforDisplay, setAmountInDollarsForDisplay] = useState('')
	const { amountChanged, initialValue = 0, isSubtraction = false } = props

	useEffect(() => {
		const initialValueToInt = parseInt(initialValue, 10)
		if (initialValueToInt > 0) {
			const centsToDollars = initialValueToInt / 100
			setAmountInDollarsForDisplay(centsToDollars.toString())
		} else {
			setAmountInDollarsForDisplay('')
		}
	}, [initialValue])

	const handleCurrencyEntry = (e) => {
		const { value } = e.target

		const numAndDecimalRegex = /^(\d+)(\.\d{0,2})?/
		if (numAndDecimalRegex.test(value) === false) {
			setAmountInDollarsForDisplay('')
			if (amountChanged) {
				amountChanged({ inCents: 0, asFormatted: '' })
			}
			return
		}

		const hasDecimal = value.includes('.')
		if (!hasDecimal) {
			setAmountInDollarsForDisplay(value)
			const valToCents = parseInt(value, 10) * 100
			amountChanged({ inCents: valToCents, asFormatted: value })
			return
		}

		const regex = /^(\d+)?(\.\d{0,2})?/
		const match = value.match(regex)
		if (match) {
			const [_, whole, decimal] = match
			const dollars = whole || '0'
			const cents = decimal || '0'
			setAmountInDollarsForDisplay(`${dollars}${cents}`)
			const floatToCents = parseInt(parseFloat(`${dollars}${cents}`) * 100, 10)
			amountChanged({ inCents: floatToCents, asFormatted: `${dollars}${cents}` })
		}
	}

	const updatedProps = { ...props }
	if (updatedProps.amountChanged) {
		delete updatedProps.amountChanged
	}
	if (updatedProps.initialValue) {
		delete updatedProps.initialValue
	}
	if (updatedProps.isSubtraction) {
		delete updatedProps.isSubtraction
	}

	updatedProps.InputProps = {
		startAdornment: (
			<InputAdornment className={classes.currencyAdornment} position="start">
				{isSubtraction ? '-$' : '$'}
			</InputAdornment>
		)
	}

	updatedProps.value = amountInDollarsforDisplay
	updatedProps.onChange = (e) => {
		handleCurrencyEntry(e)
	}

	return <StyledTextField {...updatedProps} />
}

export default StyledCurrencyTextField
